import React from 'react'
import { FieldRenderProps } from 'react-final-form'
import { SelectField } from '@cinch-labs/design-system'
import showRealtimeError from '@cinch/oxd-components/error/src/show-realtime-error'

interface FieldSelectProps
  extends FieldRenderProps,
    Omit<React.ComponentProps<typeof SelectField>, 'oxdDisplayInvalid' | 'oxdDisplayValid'> {
  showErrorCondition?: (meta: FieldRenderProps['meta']) => boolean
}

const FieldSelect: React.FC<FieldSelectProps> = ({
  meta,
  input,
  disabled,
  options,
  oxford = false,
  id,
  showErrorCondition = showRealtimeError,
  ...rest
}) => {
  const displayInvalid = oxford && meta && meta.touched && meta.invalid
  const displayValid = oxford && meta && meta.touched && meta.valid

  return (
    <SelectField
      id={id || input.name}
      value={input.value}
      onChange={input.onChange}
      onBlur={input.onBlur}
      onFocus={input.onFocus}
      disabled={disabled || options.length === 0}
      options={options}
      error={{ show: showErrorCondition(meta), message: meta.error || meta.submitError }}
      oxdDisplayInvalid={displayInvalid}
      oxdDisplayValid={displayValid}
      oxford={oxford}
      {...rest}
    />
  )
}

export default FieldSelect
